<template>
  <div>
    <b-alert
      show
      variant="primary"
    >
      <div class="alert-body">
        <feather-icon
          class="mr-25"
          icon="UserIcon"
        />
        <span class="ml-25">Datos Empleado</span>
      </div>
    </b-alert>
    <div
      v-if="isRequired && empleado"
      class="mx-1 mb-0">
      <h5 class="text-capitalize mb-75">
        Número de placa:
      </h5>
      <b-card-text>
        {{ empleado.numero_empleado }}
      </b-card-text>
      <h5 class="text-capitalize mb-75">
        Grado:
      </h5>
      <b-card-text>
        {{ empleado.grado }}
      </b-card-text>
      <h5 class="text-capitalize mb-75">
        Adscripción:
      </h5>
      <b-card-text>
        {{ empleado.adscripcion }}
      </b-card-text>
      <h5 class="text-capitalize mb-75">
        Subsecretaría adscripción:
      </h5>
      <b-card-text>
        {{ empleado.subsecretaria_adscripcion }}
      </b-card-text>
      <h5 class="text-capitalize mb-75">
        CUIP:
      </h5>
      <b-card-text>
        {{ empleado.cuip }}
      </b-card-text>
      <h5 class="text-capitalize mb-75">
        Fecha de alta SSC:
      </h5>
      <b-card-text>
        {{ empleado.fecha_alta_ssc }}
      </b-card-text>
      <h5 class="text-capitalize mb-75">
        Tiempo de Servicio:
      </h5>
      <b-card-text>
        {{ empleado.tiempo_servicio }}
      </b-card-text>
      <h5 class="text-capitalize mb-75">
        Jefe inmediato:
      </h5>
      <b-card-text>
        {{ empleado.jefe_inmediato }}
      </b-card-text>
    </div>
    <div v-else>
      <h5 class="ml-1">Esta convocatoria no requiere estos datos.</h5>
    </div>
  </div>
</template>

<script>

import {
  BAlert,
  BCardText,
} from 'bootstrap-vue'

export default {
  components: {
    BAlert,
    BCardText,
  },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    data: {
      type: [Object, Array],
      default: () => {},
    },
    isRequired: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      empleado: null,
    }
  },
  mounted() {
    this.empleado = { ...this.data }
  },
}
</script>

<style>

</style>
